module.exports = __webpack_public_path__ + "public/4197a2296f1fed40bfa517849ce45bf7.ttf";